<template>
  <vue-flux
    :options="vfOptions"
    :images="vfImages"
    :transitions="vfTransitions"
    :captions="vfCaptions"
    ref="slider"
  >
    <template v-slot:preloader>
      <flux-preloader />
    </template>

    <template v-slot:caption>
      <flux-caption />
    </template>

    <template v-slot:controls>
      <flux-controls />
    </template>

    <template v-slot:pagination>
      <flux-pagination />
    </template>
  </vue-flux>
</template>

<script>
  import {
    VueFlux,
    FluxCaption,
    FluxControls,
    FluxIndex,
    FluxPagination,
    FluxPreloader
  } from 'vue-flux';

  export default {
    name: 'bird-photo-slider',
    components: {
      VueFlux,
      FluxCaption,
      FluxControls,
      FluxIndex,
      FluxPagination,
      FluxPreloader
    },
    data() {
      return {
        vfOptions: {
          autoplay: true
        },
        vfImages: [
          '/images/slider/6026-g-pic-coq.jpg',
          '/images/slider/Passerin_Indigo_650_430.jpg',
          '/images/slider/Plongeon_Huard_650x430.jpg',
          '/images/slider/Hirondelle_650_430.jpg',
          '/images/slider/colibri-r-morin-170911.jpg'
        ],
        vfTransitions: [ 'fade' ],
        vfCaptions: [
          "Grand pic, L'Ange-Gardien, Ⓒ Guylaine Tremblay, mars 2018",
          'Passerin indigo, Orsainville, Ⓒ Réjean Paquet juin 2017',
          'Plongeon Huard, Marais du Nord, Ⓒ Réjean Paquet juin 2017',
          'Hirondelle bicolore, Marais Léon-Provancher, Ⓒ Réjean Paquet mai 2017',
          'Colibri à gorge rubis, Lac-Saint-Charles, Ⓒ Robert Morin'
        ]
      };
    }
  };
</script>

<style scoped></style>
